import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Autocomplete, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Formik, Form } from "formik";
import { NumericFormat } from "react-number-format";
import { Spinner } from "react-bootstrap";
import { currentTenant, thousandsdisplay, userid } from "../../Common/Credentials";
import CategoryServices from "../../Masters/Category/CategoryServices";
import WarehouseServices from "../../Masters/Warehouse/WarehouseServices";
import InventoryService from "../InventoryService";
import Swal from "sweetalert2";
import Footer from '../../Component/Footer'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'

const Damage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: propId, pagename } = location.state || { id: -1, pagename: "Add Losses" };

  // State (non-formik)
  const [itemsList, setItemsList] = useState([]);
  const [filteritemlist, setFilteritemlist] = useState([]);
  const [WarehouseList, setWarehouseList] = useState([]);
  const [CategoryList, setCategoryList] = useState([]);
  const [stocklist, setStocklist] = useState([]);
  const [batchidList, setBatchidList] = useState([]);
  const [selected, setSelected] = useState(false);
  const [currentstock, setCurrentstock] = useState(0);
  const [price, setPrice] = useState("");
  const [sid, setSid] = useState("");
  const [batchid, setBatchid] = useState("");
  const [comment, setComment] = useState("Other");
  const [warehouse, setWarehouse] = useState("");
  const [whid, setWhid] = useState("");
  const [category, setCategory] = useState("");
  const [catid, setCatid] = useState("");
  const [itemname, setItemname] = useState("");
  const [itemid, setItemid] = useState("");
  const [quantity, setQuantity] = useState("");
  const [sloader, setSloader] = useState(false);
  const [hovered, setHovered] = useState(null);

  const comments = ["Damaged", "Shortage", "Other"];

  useEffect(() => {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      navigate("/");
      return;
    }

    // Load initial data
    CategoryServices.getCategory(currentTenant)
      .then((response) =>
        setCategoryList(response.data.filter((e) => e.categorytype === "Product"))
      )
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          navigate("/");
        }
      });

    InventoryService.getItemNames(currentTenant).then((response) =>
      setItemsList(response.data)
    );

    WarehouseServices.getWarehouses(currentTenant).then((response) =>
      setWarehouseList(response.data)
    );

    InventoryService.retriveStock(currentTenant).then((response) =>
      setStocklist(response.data)
    );

    // If editing
    if (propId !== -1) {
      InventoryService.GetDamagedDataById(propId).then((res) => {
        const data = res.data;
        setItemid(data.itemid);
        setItemname(data.itemname);
        setCategory(data.category);
        setCatid(data.catid);
        setWarehouse(data.whname);
        setWhid(data.whid);
        setSid(data.sid);
        setPrice(data.price);
        setQuantity(parseFloat(data.quantity));
        setCurrentstock(parseFloat(data.quantity));
        setComment(data.comment);
        setBatchid(data.batchid);
      });
    }
  }, [navigate, propId]);

  // Handlers
  const warehouseChange = (event, newValue) => {
    if (newValue && typeof newValue === "object") {
      setWarehouse(newValue.name);
      setWhid(newValue.id);
      setSelected(false);
      setItemid("");
      setItemname("");
      setBatchidList([]);
      setCatid("");
      setCategory("");
      setFilteritemlist([]);
    } else {
      setWarehouse("");
      setWhid("");
      setSelected(false);
      setItemid("");
      setItemname("");
      setBatchidList([]);
      setCatid("");
      setCategory("");
      setFilteritemlist([]);
    }
  };

  const handleCategory = (event, newValue) => {
    if (newValue && typeof newValue === "object") {
      setCatid(newValue.id);
      setCategory(newValue.category);
      setFilteritemlist(itemsList.filter((e) => e.catid === newValue.id));
      setSelected(false);
      setItemid("");
      setItemname("");
      setBatchidList([]);
    } else {
      setCatid("");
      setCategory("");
      setFilteritemlist([]);
      setSelected(false);
      setItemid("");
      setItemname("");
      setBatchidList([]);
    }
  };

  const handleItemSelect = (event, newValue) => {
    if (newValue && typeof newValue === "object") {
      setSelected(true);
      setItemid(newValue.id);
      setItemname(newValue.name);
      setBatchidList(
        stocklist.filter((e) => e.wid === whid && e.name === newValue.name)
      );
    } else {
      setSelected(false);
      setItemid("");
      setItemname("");
      setBatchidList([]);
    }
  };

  const handleBatchSelect = (e) => {
    setBatchid(e.batchid);
    setPrice(e.rate);
    setCurrentstock(e.currentStock);
    setSelected(false);
    setSid(e.sid);
  };

  const onfocus = (e) => {
    e.target.addEventListener("mousewheel", function (event) {
      if (window.document.activeElement.type === "number") {
        event.preventDefault();
      }
    });
    e.target.addEventListener("keydown", function (e) {
      if (e.which === 38 || e.which === 40) {
        e.preventDefault();
      }
    });
  };

  const validate = (values) => {
    const errors = {};
    if (!whid) errors.warehouse = "Please Select Org Unit";
    if (!catid) errors.category = "Please Select Category";
    if (!itemid) errors.itemname = "Please Select Item";
    if (!quantity || quantity === "") {
      errors.quantity = "Please Enter Quantity";
    } else if (parseFloat(quantity) <= 0 && propId === -1) {
      errors.quantity = "Value Should be greater than 0";
    } else if (parseFloat(quantity) < 0) {
      errors.quantity = "Value Should be greater than or equal to 0";
    } else if (parseFloat(quantity) > currentstock) {
      errors.quantity = `Value Should be less than or equal to batch quantity ${currentstock}`;
    }
    return errors;
  };

  const onSubmit = (values, { setSubmitting }) => {
    const data = {
      id: propId,
      tenantid: currentTenant,
      createdby: userid,
      updatedby: userid,
      itemid: itemid,
      itemname: itemname,
      category: category,
      categoryid: catid,
      warehouse: warehouse,
      whid: whid,
      sid: sid,
      price: price,
      quantity: parseFloat(quantity),
      comment: comment,
      batchid: batchid,
      totalloss: price * parseFloat(quantity),
    };

    if (propId === -1) {
      setSloader(true);
      InventoryService.AddDamage(data)
        .then(() => {
          setSloader(false);
          Swal.fire({
            title: `Losses added successfully`,
            text: ".",
            icon: "success",
            confirmButtonText: "Ok",
            confirmButtonColor: "#152f5f",
          }).then(() => navigate(-1));
        })
        .catch((e) => {
          setSloader(false);
          if (e.response?.data?.error === "Unauthorized") {
            Swal.fire({
              title: `Your Session is Lost: Please login Back to resume`,
              text: ".",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            }).then(() => navigate("/"));
          } else {
            Swal.fire({
              title: `${e.response?.data?.message}`,
              text: ".",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            });
          }
        });
    } else {
      Swal.fire({
        title: "Revert losses quantity?",
        text: "The quantity you added will be moved from losses to stock",
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonColor: "#152f5f",
        confirmButtonText: "Ok",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          setSloader(true);
          InventoryService.EditLossesentery(data)
            .then(() => {
              setSloader(false);
              Swal.fire({
                title: `Losses Updated successfully`,
                text: ".",
                icon: "success",
                confirmButtonText: "Ok",
                confirmButtonColor: "#152f5f",
              }).then(() => navigate(-1));
            })
            .catch((e) => {
              setSloader(false);
              if (e.response?.data?.error === "Unauthorized") {
                Swal.fire({
                  title: `Your Session is Lost: Please login Back to resume`,
                  text: ".",
                  icon: "error",
                  confirmButtonText: "Ok",
                  confirmButtonColor: "#152f5f",
                }).then(() => navigate("/"));
              } else {
                Swal.fire({
                  title: `${e.response?.data?.message}`,
                  text: ".",
                  icon: "error",
                  confirmButtonText: "Ok",
                  confirmButtonColor: "#152f5f",
                });
              }
            });
        }
      });
    }
    setSubmitting(false);
  };

  return (
    <div>
         <Header />
      <Menu />
      <div className="content-wrapper">
      {sloader && (
        <div className="UI-loading-overlay">
          <div className="UI-spinner"></div>
        </div>
      )}

      <div className="UI-container">
        <div className="UI-card">
          <div className="UI-header">
            <nav className="UI-breadcrumb">
              <Link
                to="/inventory"
                className={`UI-breadcrumb-item ${hovered === "home" ? "UI-breadcrumb-item-hover" : ""}`}
                onMouseEnter={() => setHovered("home")}
                onMouseLeave={() => setHovered(null)}
              >
                Home
              </Link>
              <span>/</span>
              <Link
                to="/losses"
                className={`UI-breadcrumb-item ${hovered === "losses" ? "UI-breadcrumb-item-hover" : ""}`}
                onMouseEnter={() => setHovered("losses")}
                onMouseLeave={() => setHovered(null)}
              >
                Losses
              </Link>
              <span>/</span>
              <span className="UI-breadcrumb-active">
                {propId === -1 ? "Add Losses" : "Revert Losses"}
              </span>
            </nav>

            <div className="UI-header-content">
              <div>
                <h1 className="UI-title">
                  {propId === -1 ? "Add Losses" : "Revert Losses"}
                </h1>
                <p className="UI-subtitle">
                  {propId === -1
                    ? "Record damaged or missing items"
                    : "Revert previously recorded losses back to stock"}
                </p>
              </div>
              <div className="UI-header-actions">
                <button
                  onClick={() => navigate(-1)}
                  className={`UI-btn UI-btn-outline ${hovered === "back" ? "UI-btn-outline-hover" : ""}`}
                  style={{
                    backgroundColor: hovered === "back" ? "#4d4d4d" : "#ffffff",
                    color: hovered === "back" ? "#fff" : "#4d4d4d",
                    transform: hovered === "back" ? "scale(1.02)" : "scale(1)",
                    border: "1px solid #4d4d4d",
                    cursor: "pointer",
                  }}
                  onMouseEnter={() => setHovered("back")}
                  onMouseLeave={() => setHovered(null)}
                >
                  ← Back
                </button>
              </div>
            </div>
          </div>

          <div className="UI-form-container">
            <Formik
              initialValues={{}}
              onSubmit={onSubmit}
              validate={validate}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {({ errors, isSubmitting, handleSubmit }) => (
                <Form onSubmit={handleSubmit} autoComplete="off">
                  <div className="UI-form-section">
                    <h3
                      className="UI-section-title"
                      style={{ borderBottom: "1px solid #e2e8f0", paddingBottom: "6px" }}
                    >
                      Loss Details
                    </h3>

                    <div className="UI-form-grid">
                      {/* Warehouse */}
                      <div className="UI-form-group">
                        <label className="UI-label">Org Unit *</label>
                        <Autocomplete
                          options={WarehouseList}
                          getOptionLabel={(option) => option.name}
                          value={WarehouseList.find((w) => w.id === whid) || null}
                          onChange={warehouseChange}
                          disabled={propId !== -1}
                          renderInput={(params) => (
                            <div ref={params.InputProps.ref}>
                              <input
                                {...params.inputProps}
                                className={`UI-input ${errors.warehouse ? "UI-input-error" : ""}`}
                                placeholder="Select org unit"
                              />
                            </div>
                          )}
                        />
                        {errors.warehouse && (
                          <div className="UI-error-text">{errors.warehouse}</div>
                        )}
                      </div>

                      {/* Category */}
                      <div className="UI-form-group">
                        <label className="UI-label">Category *</label>
                        <Autocomplete
                          options={CategoryList}
                          getOptionLabel={(option) => option.category}
                          value={CategoryList.find((c) => c.id === catid) || null}
                          onChange={handleCategory}
                          disabled={propId !== -1}
                          renderInput={(params) => (
                            <div ref={params.InputProps.ref}>
                              <input
                                {...params.inputProps}
                                className={`UI-input ${errors.category ? "UI-input-error" : ""}`}
                                placeholder="Select category"
                              />
                            </div>
                          )}
                        />
                        {errors.category && (
                          <div className="UI-error-text">{errors.category}</div>
                        )}
                      </div>

                      {/* Item */}
                      <div className="UI-form-group">
                        <label className="UI-label">Item *</label>
                        <Autocomplete
                          options={filteritemlist}
                          getOptionLabel={(option) => option.name}
                          value={filteritemlist.find((i) => i.id === itemid) || null}
                          onChange={handleItemSelect}
                          disabled={propId !== -1}
                          renderInput={(params) => (
                            <div ref={params.InputProps.ref}>
                              <input
                                {...params.inputProps}
                                className={`UI-input ${errors.itemname ? "UI-input-error" : ""}`}
                                placeholder="Select item"
                              />
                            </div>
                          )}
                        />
                        {errors.itemname && (
                          <div className="UI-error-text">{errors.itemname}</div>
                        )}
                      </div>
                    </div>

                    {/* Batch Selection Table */}
                    {selected && batchidList.length > 0 && (
                      <div className="UI-form-group" style={{ marginTop: "16px" }}>
                        <label className="UI-label">Available Batches</label>
                        <TableContainer
                          className="UI-table-container"
                          style={{ maxHeight: "300px", overflowY: "auto" }}
                        >
                          <table className="UI-table">
                            <thead className="UI-table-header" style={{ position: "sticky", top: 0 }}>
                              <tr>
                                <th className="UI-th">Item</th>
                                <th className="UI-th">Batch ID</th>
                                <th className="UI-th">Stock Type</th>
                                <th className="UI-th">Price</th>
                                <th className="UI-th">Stock</th>
                                <th className="UI-th">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {batchidList.map((e, i) => (
                                <tr
                                  key={i}
                                  style={{ backgroundColor: i % 2 === 0 ? "#f8fafc" : "#ffffff" }}
                                >
                                  <td className="UI-td">{e.name}</td>
                                  <td className="UI-td">{e.custombatchid}</td>
                                  <td className="UI-td">{e.stocktype}</td>
                                  <td className="UI-td" style={{ textAlign: "right" }}>
                                    <NumericFormat
                                      displayType="text"
                                      value={e.rate}
                                      decimalScale={2}
                                      fixedDecimalScale
                                      thousandSeparator
                                      thousandsGroupStyle={thousandsdisplay}
                                    />
                                  </td>
                                  <td className="UI-td">{e.currentStock}</td>
                                  <td className="UI-td">
                                    <button
                                      type="button"
                                      onClick={() => handleBatchSelect(e)}
                                      className="UI-btn UI-btn-primary"
                                      style={{ fontSize: "0.7rem", padding: "4px 8px" }}
                                    >
                                      Select
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </TableContainer>
                      </div>
                    )}

                    {/* Selected Batch Details */}
                    {!selected && itemid && (
                      <div className="UI-form-grid" style={{ marginTop: "16px" }}>
                        <div className="UI-form-group">
                          <label className="UI-label">Price</label>
                          <input
                            type="text"
                            className="UI-input UI-input-disabled"
                            value={price || ""}
                            disabled
                          />
                        </div>

                        <div className="UI-form-group">
                          <label className="UI-label">
                            Quantity (Available: {currentstock}) *
                          </label>
                          <input
                            id="quantity"
                            type="number"
                            className={`UI-input ${errors.quantity ? "UI-input-error" : ""}`}
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                            onFocus={onfocus}
                            min="0"
                            step="0.01"
                          />
                          {errors.quantity && (
                            <div className="UI-error-text">{errors.quantity}</div>
                          )}
                        </div>

                        <div className="UI-form-group" style={{ gridColumn: "span 2" }}>
                          <label className="UI-label">Comment/Reason *</label>
                          <textarea
                            className={`UI-textarea ${!comment ? "UI-input-error" : ""}`}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="Enter comment or reason"
                            rows="2"
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Note for edit mode */}
                  {propId !== -1 && (
                    <div className="UI-form-group">
                      <div
                        style={{
                          padding: "12px",
                          borderRadius: "6px",
                          backgroundColor: "#fffbeb",
                          border: "1px solid #fef3c7",
                          color: "#92400e",
                          fontSize: "0.85rem",
                        }}
                      >
                        <strong>Note:</strong> The entered quantity will be moved from losses to
                        corresponding batch stock.
                      </div>
                    </div>
                  )}

                  <div className="UI-btn-actions">
                    <Link
                      to="/losses"
                      className={`UI-btn UI-btn-outline ${hovered === "cancel" ? "UI-btn-outline-hover" : ""}`}
                      style={{
                        backgroundColor: hovered === "cancel" ? "#4d4d4d" : "#ffffff",
                        color: hovered === "cancel" ? "#fff" : "#4d4d4d",
                        transform: hovered === "cancel" ? "scale(1.03)" : "scale(1)",
                        border: "1px solid #4d4d4d",
                        textDecoration: "none",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onMouseEnter={() => setHovered("cancel")}
                      onMouseLeave={() => setHovered(null)}
                    >
                      Cancel
                    </Link>
                    <button
                      type="submit"
                      disabled={isSubmitting || sloader}
                      className={`UI-btn UI-btn-primary ${hovered === "submit" ? "UI-btn-primary-hover" : ""}`}
                      style={{
                        opacity: isSubmitting || sloader ? 0.6 : 1,
                        transform: hovered === "submit" ? "scale(1.07)" : "scale(1)",
                      }}
                      onMouseEnter={() => setHovered("submit")}
                      onMouseLeave={() => setHovered(null)}
                    >
                      {sloader ? (
                        <>
                          <Spinner animation="border" size="sm" /> Saving...
                        </>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
      </div>
      <Footer />
    </div>
  );
};

export default Damage;